__turbopack_context__.v({
  "loader": "PageLoader-module-scss-module__hRYpvG__loader",
});
